import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';

import { apiErrorMessage } from '../../shared/api/errors';
import { Button } from '../../shared/ui/Button';
import { inputClass, TextField } from '../../shared/ui/TextField';
import { Card } from '../../shared/ui/primitives';
import { Logo } from '../../shared/ui/Logo';
import { submitPartnership, type PartnershipInput } from './api';

/** Публичная форма заявки «Сотрудничество» — кнопка из письма со снимками. */
export function PartnershipPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PartnershipInput>();
  const mutation = useMutation({ mutationFn: submitPartnership });

  return (
    <div className="flex min-h-screen items-center justify-center px-4 py-10">
      <div className="w-full max-w-md space-y-6">
        <div className="flex justify-center">
          <Logo size="lg" className="flex-col gap-2" />
        </div>

        <Card className="space-y-4 p-6">
          <h1 className="text-lg font-semibold text-ink">Сотрудничество</h1>

          {mutation.isSuccess ? (
            <p className="text-sm text-ink">Спасибо! Заявка отправлена — мы свяжемся с вами.</p>
          ) : (
            <form onSubmit={handleSubmit((v) => mutation.mutate(v))} className="space-y-3">
              <p className="text-sm text-muted">Оставьте контакты — мы свяжемся с вами.</p>
              <TextField
                label="ФИО *"
                autoComplete="name"
                error={errors.fullName?.message}
                {...register('fullName', { validate: (v) => v.trim() !== '' || 'Укажите ФИО' })}
              />
              <TextField label="Клиника" autoComplete="organization" {...register('clinic')} />
              <TextField label="Город" autoComplete="address-level2" {...register('city')} />
              <TextField
                label="Телефон *"
                type="tel"
                autoComplete="tel"
                error={errors.phone?.message}
                {...register('phone', { validate: (v) => v.trim() !== '' || 'Укажите телефон' })}
              />
              <TextField label="E-mail" type="email" autoComplete="email" {...register('email')} />
              <label className="block text-sm">
                <span className="mb-1 block font-medium text-ink/80">Комментарий</span>
                <textarea
                  rows={4}
                  maxLength={2000}
                  className={inputClass}
                  {...register('comment')}
                />
              </label>
              {mutation.isError && (
                <p className="text-sm text-danger">
                  {apiErrorMessage(mutation.error, 'Не удалось отправить заявку')}
                </p>
              )}
              <Button type="submit" disabled={mutation.isPending} className="w-full">
                {mutation.isPending ? 'Отправляем…' : 'Отправить заявку'}
              </Button>
            </form>
          )}
        </Card>
      </div>
    </div>
  );
}
